import { toast } from "sonner";

export const useToast = () => {
  const isMobile = window.innerWidth <= 768; // Simple mobile detection

  const getCloseOptions = (customOptions = {}) => ({
    closeButton: !isMobile, // Show close button only on desktop
    dismissible: true, // Allow swipe dismiss on mobile
    swipeDirection: isMobile ? "up" : undefined, // Swipe up on mobile
    ...customOptions,
  });

  return {
    show: (title, body, options = {}) => {
      return toast(title, {
        description: body,
        ...getCloseOptions(options),
      });
    },

    promise: (promise, messages, options = {}) => {
      const closeOptions = getCloseOptions(options);

      const toastId = toast.loading(messages.loading.title, {
        description: messages.loading.body,
        ...closeOptions,
      });

      promise
        .then(() => {
          toast.success(messages.success.title, {
            id: toastId,
            description: messages.success.body,
            ...closeOptions,
          });
        })
        .catch(() => {
          toast.error(messages.error.title, {
            id: toastId,
            description: messages.error.body,
            ...closeOptions,
          });
        });

      return toastId;
    },

    dismiss: (toastId) => toast.dismiss(toastId),
    dismissAll: () => toast.dismiss(),
  };
};
